import { addContextUpdateListener, getContext } from '@dvag/dfs-orchestrator-client';
import { FeatureDefinition, GrowthBook } from '@growthbook/growthbook-react';

import { queryClient } from 'config/reactQuery';

type FeatureFlag = {
  gb: GrowthBook<Record<string, unknown>>;
  init: () => void;
};

type OrchestratorFeatureFlagValue = boolean | FeatureDefinition<unknown>;
type OrchestratorFeatureFlags = Record<string, OrchestratorFeatureFlagValue> | undefined;

let isInitialized = false;

const mapFeatureFlags = (
  featureFlags: OrchestratorFeatureFlags,
): Record<string, FeatureDefinition<unknown>> =>
  Object.fromEntries(
    Object.entries(featureFlags ?? {}).map(([key, value]) => [
      key,
      typeof value === 'boolean' ? { defaultValue: value } : value,
    ]),
  );

const featureFlag: FeatureFlag = {
  gb: new GrowthBook(),

  init: () => {
    if (isInitialized) {
      return;
    }

    const context = getContext();

    featureFlag.gb.setAttributes({
      advisorId: context.user?.advisor?.id,
    });

    featureFlag.gb.initSync({
      payload: {
        features: mapFeatureFlags(context.featureFlags),
      },
    });

    addContextUpdateListener((updatedContext) => {
      featureFlag.gb.setAttributes({
        advisorId: updatedContext.user?.advisor?.id,
      });

      featureFlag.gb.setPayload({
        features: mapFeatureFlags(updatedContext.featureFlags),
      });

      queryClient.cancelQueries({ queryKey: ['getPolicies'] });
      queryClient.invalidateQueries({ queryKey: ['getPolicies'] });
    });

    isInitialized = true;
  },
};

export default featureFlag;
